import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

export type MissionSpecialistProgramInstanceDetailResponse = {
  programInstanceId: string
  programInstanceName: string
  displayName: string | null
  msDisplayName: string | null
  programGroupId: string
  programGroupName: string
  programGroupDisplayName: string | null
  liveProgramId: string
  recyclerProgramId: string | null
  recyclerTrainingProgramId: string | null
  iconType: string | null
  color: string | null
  isEligible: boolean
  liveEligible: boolean
  recyclerEligible: boolean
  recyclerTrainingAssigned: boolean
  recyclerTrainingCertified: boolean
  recyclerTrainingProgress: number | null
  hasTaskHistory: boolean
  totalIncorrectUnread: number
  totalUnreadComments: number
}

export const MSProgramInstanceDetailKey = 'mission-specialist-program-instance-detail'

export function useProgramInstanceDetail(programInstanceId?: string) {
  return useQuery({
    queryKey: [MSProgramInstanceDetailKey, programInstanceId],
    queryFn: async () =>
      (
        await apiClient.get<MissionSpecialistProgramInstanceDetailResponse>(
          `/int/v3/operators/program-instances/${programInstanceId}`
        )
      ).data,
    enabled: Boolean(programInstanceId),
    refetchOnWindowFocus: false,
  })
}
